<script setup lang="ts">
	import VueDatePicker from "@vuepic/vue-datepicker";
  import moment from 'moment';
	import "@vuepic/vue-datepicker/dist/main.css";

	const props = withDefaults(
		defineProps<{
			modelValue?: string;
			locale?: string;
			monthPicker?: boolean;
			yearPicker?: boolean;
			marginRight?: number;
			marginLeft?: number;
      teleportCenter? : boolean;
      minDate?: string | null;
      maxDate?: string | null;
      pickerPosition?: string | null;
      altPosition?: {top: number, left: number} | null;
			disabled?: boolean
			isIcon?: boolean
		}>(),
		{
			modelValue: new Date().toString(),
			locale: "ko-kr",
			monthPicker: false,
			yearPicker: false,
			marginRight: 0,
			marginLeft: 0,
      teleportCenter : true,
      minDate: null,
      maxDate: null,
      pickerPosition: 'center',
      altPosition: null,
			disabled: false,
			isIcon: false
		}
	);

	const emit = defineEmits(["update:modelValue", "setVmodel"]);
                                                          
	const marginRight = computed(() => {
		return `${props.marginRight}px`;
	});
	const marginLeft = computed(() => {
		return `${props.marginLeft}px`;
	});

	function dateUpdate(value: string) {

		// 동일한 값인 경우 이벤트 발생 방지
		if (props.modelValue === value) {
			console.log('📅 DatePicker: 동일한 날짜입니다. 이벤트를 건너뜁니다.');
			return;
		}
		
		emit('setVmodel', value.toString());
		console.log('📅 DatePicker: 날짜 변경됨:', value);
	}
</script>

<template>
	<VueDatePicker
		class="calendarPicker"
		:modelValue.string="props.modelValue"
		:week-start="0"
		:locale="props.locale"
    :min-date="props.minDate === null ? null : moment(props.minDate).toDate()"
		:max-date="props.maxDate === null ? new Date() : moment(props.maxDate).toDate()"
		:position="props.pickerPosition"
    :teleport="props.teleportCenter"
		:input-icon="true"
		auto-apply
		:month-picker="props.monthPicker"
		:year-picker="props.yearPicker"
		:enable-time-picker="false"
		:disabled="props.disabled"
		model-type="yyyy-MM-dd"
		@update:model-value="dateUpdate"
	>
		<template #input-icon>
			<slot name="input-icon"></slot>
		</template>
		<template #trigger>
			<slot name="contents"></slot>
		</template>
	</VueDatePicker>
</template>

<style lang="scss" scoped>
	@use "@/assets/styles/design-toc/define_font.scss";
	$margin-right: v-bind(marginRight);
	$margin-left: v-bind(marginLeft);

	.input-slot-image {
    height: 20px;
    width: auto;
    margin-left: 5px;
	}

	.calendarPicker {
		@include define_font.text-normal-14;
		margin-right: $margin-right;
		margin-left: $margin-left;
		border-radius: 6px;
		background: #FFF;
		width: auto;
	}
</style>
